<template>
  <div id="entrys">
    <!-- <div class="common-header container" @click="goHome">
      <div class="logo"></div>
      <div title="" class="title">{{ mecoName }}机考模拟系统</div>
    </div> -->

    <div class="doExam">
      <div class="headerTop">
        <div class="pic fl"><img src="../../../public/images/touxiang.png" /></div>
        <div class="ids fl">
          <p>m930742868</p>
          <p>1111111111110000</p>
        </div>
        <div class="fl course">
          <div>
            <p>电子化模拟系统</p>
            <p>{{ mecoTitle }}</p>
          </div>
        </div>
        <div class="fl tim">
          <div>
            <p>机位：{{ mecoSeat }}</p>
            <div class="Timer fl time">
              剩余时间: <span>{{ countSecond }}</span>
            </div>
          </div>
          <button type="button" class="end fr" @click="submitPaper">交卷</button>
        </div>
      </div>

      <div class="mainContent" style="">
        <div class="leftCon fl" v-if="meauLeft == 1">
          <div class="main_new">
            <ul>
              <li :class="judge == 1 ? 'qitem active' : 'qitem'" v-if="jsonData.judge > 0">
                <p class="qtitle" @click="judgeChange">判断题</p>
                <div class="num_box clearfix">
                  <div @click="nextQuestion(item)" :class="index == item
      ? 'nitem cur'
      : questionData[item - 1].user_answer_right != -1
        ? 'nitem yes'
        : 'nitem'
      " v-for="item in jsonData.judge" :key="item">
                    {{ item }}
                    <span v-if="questionData[item - 1].mark == true"></span>
                  </div>
                </div>
              </li>
              <li :class="radio == 1 ? 'qitem active' : 'qitem'" v-if="jsonData.radio > 0">
                <p class="qtitle" @click="radioChange">单项选择题</p>
                <div class="num_box clearfix">
                  <div @click="nextQuestion(jsonData.judge + item)" :class="index == jsonData.judge + item
      ? 'nitem cur'
      : questionData[jsonData.judge + item - 1].user_answer_right != -1
        ? 'nitem yes'
        : 'nitem'
      " v-for="item in jsonData.radio" :key="item">
                    {{ jsonData.judge + item }}
                    <span v-if="questionData[jsonData.judge + item - 1].mark == true"></span>
                  </div>
                </div>
              </li>
              <li :class="checkbox == 1 ? 'qitem active' : 'qitem'" v-if="jsonData.checkbox > 0">
                <p class="qtitle" @click="checkboxChange">多项选择题</p>
                <div class="num_box clearfix">
                  <div @click="nextQuestion(jsonData.judge + jsonData.radio + item)" :class="index == jsonData.judge + jsonData.radio + item
      ? 'nitem cur'
      : questionData[jsonData.judge + jsonData.radio + item - 1].user_answer_right != -1
        ? 'nitem yes'
        : 'nitem'
      " v-for="item in jsonData.checkbox" :key="item">
                    {{ jsonData.judge + jsonData.radio + item }}
                    <span v-if="questionData[jsonData.judge + jsonData.radio + item - 1].mark == true"></span>
                  </div>
                </div>
              </li>

              <li :class="indefinite == 1 ? 'qitem active' : 'qitem'" v-if="jsonData.indefinite > 0">
                <p class="qtitle" @click="indefiniteChange">材料分析题</p>
                <div class="num_box clearfix">
                  <div @click="nextQuestion(jsonData.judge + jsonData.radio + jsonData.checkbox + item)" :class="index == jsonData.judge + jsonData.radio + jsonData.checkbox + item
      ? 'nitem cur'
      : questionData[jsonData.judge + jsonData.radio + jsonData.checkbox + item - 1]
        .user_answer_right != -1
        ? 'nitem yes'
        : 'nitem'
      " v-for="item in jsonData.indefinite" :key="item">
                    {{ jsonData.judge + jsonData.radio + jsonData.checkbox + item }}
                    <span v-if="questionData[jsonData.judge + jsonData.radio + jsonData.checkbox + item - 1].mark == true"></span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div :class="meauLeft == 1 ? 'rightCon' : 'rightCon full'">
          <p class="explain" v-if="question.type == 0">
            判断题 (共{{ jsonData.judge }}题，每题1分。请判断每小题表述是否正确)
          </p>
          <p class="explain" v-if="question.type == 1">
            单项选择题 (共70题，每题1分。每题的备选项中，只有1个最符合题意)
          </p>
          <p class="explain" v-if="question.type == 2">
            多项选择题
            (共35题，每题2分。每题的备选项中，有2个或2个以上符合题意，至少有1个错项。错选，本题不得分；少选，所选的每个选项得0.5分)
          </p>
          <p class="explain" v-if="question.type == 4">
            案例分析题
            (共20题，每题2分。由单选和多选组成。错选，本题不得分；少选，所选的每个选项得0.5分)
          </p>

          <div class="sa-content" v-if="question.type == 4">
            <div class="sc" style="font-size: 14px" v-html="question.material"></div>
          </div>

          <div :class="fontSize == 0
      ? 'exam_content font100'
      : fontSize == 1
        ? 'exam_content font150'
        : 'exam_content font200'
      ">
            <div class="shuiyin"></div>
            <div class="full">
              <div class="full_tit">
                <div class="topic">
                  <label>{{ index }}</label>
                  <div class="text" v-html="question.title"></div>
                </div>
                <div class="full_con">
                  <ul class="topic_li">
                    <li v-for="(item, index) in currentSelectList" :key="index">
                      <div>
                        <span>{{ item.key }}.</span>
                        <div class="item_content" v-html="item.value"></div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="onlychose">
                <label class="answer_icon"> <i class="el-icon-edit"></i>请作答 </label>
                <label class="num"> m930742868 111111111111111111 </label>
                <div>
                  <ul class="topic_li" v-if="isRadioQuestion">
                    <el-radio-group v-model="radioValue" @input="selectRadio">
                      <el-radio v-for="item in currentSelectList" :key="item.key" :label="item.key">{{ item.key }}</el-radio>
                    </el-radio-group>
                  </ul>
                  <ul class="topic_li" v-if="question.type == 2 || question.type_id == 2">
                    <el-checkbox-group v-model="checkList" @change="selectCheck">
                      <el-checkbox label="A">A</el-checkbox>
                      <el-checkbox label="B">B</el-checkbox>
                      <el-checkbox label="C">C</el-checkbox>
                      <el-checkbox label="D">D</el-checkbox>
                      <el-checkbox label="E">E</el-checkbox>
                    </el-checkbox-group>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="footBottom">
            <span class="changeFull fl" @click="showMeauLeft">
              <i class="el-icon-arrow-right" v-if="meauLeft == 0"></i>
              <i class="el-icon-arrow-left" v-else></i>
            </span>
            <div class="fl">
              <input type="button" value="上一题" class="btn btn_primary" @click="nextQuestion(index - 1)" />
              <input type="button" value="下一题" class="btn btn_normal" @click="nextQuestion(index + 1)" />
            </div>
            <a href="javascript:void (0)" class="btn btn_sm" @click="openMark"><i v-if="question.mark == true"
                class="el-icon-star-on"></i>标记</a>
            <a href="javascript:void (0)" class="btn btn_sm" @click="openCalculator"><i
                class="el-icon-s-grid"></i>计算器</a>
            <div id="showBtn" class="btn btn_normal set" @click="setSeeting">
              <i class="el-icon-setting"></i>
            </div>

            <div id="queryBox" class="dropContents" v-if="showSeeting">
              <span>
                <a @click="isAuto = 1; showSeeting = false;" href="javascript:;"
                  :class="isAuto == 1 ? 'ch_auto current' : 'ch_auto'">自动切换到下一题</a>
                <a @click="isAuto = 0; showSeeting = false;" href="javascript:;"
                  :class="isAuto == 0 ? 'ch_auto current bor' : 'ch_auto bor'">手动切换到下一题</a>
              </span>
              <span>
                <a href="javascript:;" :class="fontSize == 0 ? 'changeBig current' : 'changeBig'" @click="
      fontSize = 0;
    showSeeting = false;
    ">原始大小</a>
                <a href="javascript:;" :class="fontSize == 1 ? 'changeBig current' : 'changeBig'" @click="
      fontSize = 1;
    showSeeting = false;
    ">放大50%</a>
                <a href="javascript:;" :class="fontSize == 2 ? 'changeBig current bor' : 'changeBig bor'" @click="
      fontSize = 2;
    showSeeting = false;
    ">放大100%</a>
              </span>
              <span class="last"><a href="javascript:;" class="current" @click="showMeauLeft">切换显示</a></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="window" v-if="showSubmit">
      <div class="hs"></div>
      <div class="windowContent">
        <p class="tishi">信息提示</p>
        <div class="delete">
          <div class="infoTest icon" v-if="nums > 0">
            还有{{ nums }}道题未作答，请确定全部答完后交卷！
          </div>
          <div class="infoTest icon" v-else>
            确认要提交试卷吗？
          </div>
          <div class="t_center">
            <a v-if="nums < 100" href="javascript:" class="btn" @click="confirmSubmit">确定交卷</a>
            <a v-if="nums != 0" href="javascript:" class="btn" @click="showSubmit = false">返回作答</a>
          </div>
        </div>
      </div>
    </div>

    <div class="window" v-if="showSubmitSuccess">
      <div class="hs"></div>
      <div class="windowContent">
        <p class="tishi">温馨提示</p>
        <div class="delete">
          <div class="infoTest icon"><span>交卷成功</span></div>
          <div class="t_center">
            <a href="javascript:" class="btn" @click="goResult">查看考试成绩</a>
            <a href="javascript:" class="btn" @click="closeSuccess">关闭</a>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="科学计算器" :modal="false" :modal-append-to-body="false" :close-on-click-modal="false" v-dialogDrag
      :visible.sync="dialogVisible" width="720px" :before-close="handleClose">
      <iframe src="https://www.yitku.com/calc" frameborder="0" width="100%" height="350"></iframe>
    </el-dialog>

  </div>
</template>
<script>
const { exec } = require('child_process');


export default {
  data() {
    return {
      judge: 1,
      radio: 1,
      dialogVisible: false,
      radioValue: "",
      checkList: [],
      mecoSeat: sessionStorage.getItem("access-mecoSeat"),
      mecoName: sessionStorage.getItem("access-mecoName"),
      mecoTitle: sessionStorage.getItem("access-mecoTitle"),
      checkbox: 1,
      indefinite: 1,
      meauLeft: 1,
      fontSize: 0,
      total: 0,
      showSeeting: false,
      showSubmit: false,
      showSubmitSuccess: false,
      
      hour: "",
      min: "",
      second: "",
      countSecond: "",
      // 结束日期
      endDate: new Date().getTime(),
      jsonData: [],
      questionData: [],
      question: [],
      index: 1,
      nums: 0,
      pc_id: 0,
      times: 0,
      isAuto: 1,
    };
  },
  computed: {
    isRadioQuestion() {
      return this.question.type == 0 || this.question.type == 1 || this.question.type_id == 1;
    },

    currentSelectList() {
      if (this.question.type == 0) {
        return this.normalizeJudgeOptions(this.question.select_list);
      }

      if (this.question.type == 1 || this.question.type_id == 1) {
        return this.normalizeRadioOptions(this.question.select_list);
      }

      return this.question.select_list || [];
    },
  },
  mounted: function () {
    //this.countTime();
    this.getList();
  },
  methods: {

    handleClose() {
      this.dialogVisible = false;
    },

    openCalculator() {
      this.dialogVisible = true;
    },

    normalizeJudgeOptions(options) {
      if (options && options.length > 0) {
        return options;
      }

      return [
        { key: "A", value: "对" },
        { key: "B", value: "错" },
      ];
    },

    normalizeRadioOptions(options) {
      if (options && options.length > 0) {
        return options;
      }

      return ["A", "B", "C", "D"].map((key) => ({ key, value: "" }));
    },

    normalizeQuestionCounts(paper) {
      ["judge", "radio", "checkbox", "indefinite"].forEach((key) => {
        paper[key] = Number(paper[key]) || 0;
      });
    },

    goHome() {
      this.$confirm('确认要退出考试吗？?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push("/web/index");
      });
    },

    goResult() {
      this.$router.push({
        path: "/meco/result",
        query: {
          pc_id: this.pc_id,
          column_id: this.jsonData.column_id,
        },
      });
    },

    closeSuccess() {
      let _this = this;
      sessionStorage.setItem("access-class_id", this.jsonData.class_id);
      sessionStorage.setItem("access-column_id", this.jsonData.column_id);
      sessionStorage.setItem("access-subject_id", this.jsonData.subject_id);
      this.$router.push({
        path: "/web/chapter",
        query: {
          class_id: this.jsonData.class_id,
          column_id: this.jsonData.column_id,
          subject_id: this.jsonData.subject_id,
        },
      });
    },

    selectRadio(e) {
      console.log(e);
      console.log(this.question);
      let _this = this;
      let json = this.questionData;
      let right = 0;
      json[this.index - 1].user_answer = e;
      console.log(this.question.answer);
      if (this.question.answer == e) {
        right = 1;
      }
      json[this.index - 1].user_answer_right = right;
      let formData = {};
      this.questionData = json;
      console.log(this.questionData);
      formData.pc_id = this.pc_id;
      formData.paper_id = this.question.p_id;
      formData.question_id = this.question.id;
      formData.user_answer_right = right;
      formData.user_answer = e;
      this.axios.post("/setPcQuestion", formData).then((res) => {
        if (_this.isAuto == 1) {
          _this.nextQuestion(_this.index + 1);
        }
      });
    },

    selectCheck(e) {
      console.log(e);
      let es = e.sort();
      let string = es.join("");
      console.log(string);
      let json = this.questionData;
      json[this.index - 1].user_answer = string;
      let right = 0;
      if (this.question.answer == string) {
        right = 1;
      }
      json[this.index - 1].user_answer_right = right;
      this.questionData = json;
      let formData = {};
      this.questionData = json;
      console.log(this.questionData);
      formData.pc_id = this.pc_id;
      formData.paper_id = this.question.p_id;
      formData.question_id = this.question.id;
      formData.user_answer_right = right;
      formData.user_answer = string;
      this.axios.post("/setPcQuestion", formData).then((res) => { });
    },

    submitPaper() {
      let num = 0;
      this.questionData.forEach((element) => {
        if (element.user_answer_right != -1) {
          num++;
        }
      });
      this.nums = this.total - num;
      console.log(this.nums);
      this.showSubmit = true;
    },

    //点击题号显示对应的题
    nextQuestion(ids) {
      if (ids < 1) {
        alert("已经没有题了");
        return false;
      }

      if (ids > this.questionData.length) {
        alert("已经是最后一题了");
        return false;
      }
      this.radioValue = "";
      this.checkList = [];
      let index = ids - 1;
      this.index = ids;
      this.question = this.questionData[index];
      if (ids <= 0) {
        return false;
      }
      console.log(ids);
      console.log(this.questionData.length);

      if (ids > this.questionData.length) {
        if (this.isRadioQuestion) {
          this.radioValue = this.question.user_answer;
        }
        alert("已经是最后一题了");
        return false;
      } else {
        if (this.isRadioQuestion) {
          this.radioValue = this.question.user_answer;
        } else if (this.question.type == 2 || this.question.type_id == 2) {
          this.checkList = this.question.user_answer.split("");
        }
      }
    },

    getList() {
      let that = this;
      let paper = sessionStorage.getItem('access-mecoPapers');
      console.log(JSON.parse(paper));
      let jsonPaper = JSON.parse(paper);
      this.normalizeQuestionCounts(jsonPaper);
      that.total = jsonPaper.nums;
      that.jsonData = jsonPaper;
      that.questionData = jsonPaper.lists;
      that.question = jsonPaper.lists[0];
      this.radioValue = jsonPaper.lists[0].user_answer;
      that.endDate = that.endDate + jsonPaper.stime * 60 * 1000;
      that.setPcPaper(jsonPaper.id);
      that.countTime();
    },

    //创建记录
    setPcPaper(ids) {
      let that = this;
      let formData = {};
      formData.paper_id = ids;
      that.axios.post("/setPcPaper", formData).then((res) => {
        that.pc_id = res.data;
      });
    },

    //提交试卷
    confirmSubmit() {
      //this.showSubmitSuccess = true;pc_id: this.pc_id,
      let that = this;
      let formData = {};
      formData.pc_id = that.pc_id;
      formData.times = that.times;
      formData.question = that.questionData;
      that.axios.post("/setSubmitPaper", formData).then((res) => {
        this.showSubmitSuccess = true;
      });

    },

    // 倒计时
    countTime() {
      let now = new Date().getTime(); // 获取当前时间
      let endDate = new Date(this.endDate); // 设置截止时间
      let end = Number(endDate);
      //let endDate = new Date(this.assistActivityEndTime); // this.assistActivityEndTime需要倒计时的日期
      let leftTime = end - now; // 倒计时时间差
      // 定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        // 天
        // this.day = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        // let dayh = this.day * 24
        // 时
        let h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        h = h;
        this.hour = h < 10 ? "0" + h : h;
        // 分
        let m = Math.floor((leftTime / 1000 / 60) % 60);
        this.min = m < 10 ? "0" + m : m;
        // 秒
        let s = Math.floor((leftTime / 1000) % 60);
        this.second = s < 10 ? "0" + s : s;
        this.countSecond = this.hour + ":" + this.min + ":" + this.second;
      } else {
        this.day = 0;
        this.hour = "00";
        this.min = "00";
        this.second = "00";
        this.countSecond = this.hour + ":" + this.min + ":" + this.second;
        this.confirmSubmit();
      }
      // 等于0的时候不调用
      if (
        Number(this.day) === 0 &&
        Number(this.hour) === 0 &&
        Number(this.min) === 0 &&
        Number(this.second) === 0
      ) {
        this.$route.query.count = 4;
        // 执行飞行任务
        return;
      } else {
        // 递归每秒调用countTime方法，显示动态时间效果,
        this.times = this.times + 1;
        setTimeout(this.countTime, 1000);
      }
    },

    openMark() {
      let json = this.questionData;
      json[this.index - 1].mark = !json[this.index - 1].mark;
      this.questionData = json;
    },

    setSeeting() {
      this.showSeeting = !this.showSeeting;
    },

    judgeChange() {
      this.judge = !this.judge;
    },

    radioChange() {
      this.radio = !this.radio;
    },

    checkboxChange() {
      this.checkbox = !this.checkbox;
    },

    indefiniteChange() {
      this.indefinite = !this.indefinite;
    },

    showMeauLeft() {
      this.meauLeft = !this.meauLeft;
      this.showSeeting = false;
    },
  },
};
</script>

<style>
@import "../../../public/css/meco.css";
@import "../../../public/css/doexam.css";

.el-dialog__wrapper {
  position: relative;
}

#entrys,
#entrys .main {
  width: 100% !important;
}

.container {
  width: 100% !important;
}

.el-radio,
.el-checkbox {
  color: #ffffff !important;
}

.topic_li {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.doExam .footBottom .dropContents span a.ch_auto.current {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAALCAMAAABxsOwqAAAAUVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABcqRVCAAAAGnRSTlMA+qwa4dPKjnUrEwfu28u4ppWFXFtKQzQkDHjH6eoAAABMSURBVAjXPc1JDoAgEETRBgFBnGf//Q8qEbBXL+lKldRr2l/DVBQdunAFlxUUyqeUfkSjDpGtxwfY0+80mJnly3Uj2CjZlqvW33noBZVNAuDeOVkuAAAAAElFTkSuQmCC) 10px no-repeat;
}
</style>
